import { useEffect, useMemo, useState } from 'react';
import socketService from '../../services/socketService';
import { ConversationLifecycleController } from './controller';
import { initialLifecycleState, latestLifecycleEvent } from './reducer';

export const useConversationLifecycle = (sessionId: string, workerId: string, enabled = true) => {
  const controller = useMemo(() => new ConversationLifecycleController(), []);
  const [state, setState] = useState(initialLifecycleState);

  useEffect(() => {
    if (!enabled) {
      controller.stop();
      socketService.connect();
      socketService.setActiveSession(workerId, sessionId);
      setState({ ...initialLifecycleState(sessionId), synchronized: true });
      return () => socketService.clearActiveSession(workerId, sessionId);
    }
    const unsubscribe = controller.subscribe(setState);
    void controller.start(sessionId, workerId).catch(() => setState((current) => ({ ...current, synchronized: false })));
    return () => {
      unsubscribe();
      controller.stop();
    };
  }, [controller, enabled, sessionId, workerId]);

  return { state, latest: enabled ? latestLifecycleEvent(state) : null };
};
